const defaultRender = (value) =>
  value === 0 || value ? value : "--";

const columns = [
  {
    title: "User",
    dataIndex: "user",
  },
  {
    title: "A/C No.",
    dataIndex: "login",
    render: defaultRender,
  },
  {
    title: "Deal ID",
    dataIndex: "dealId",
    render: defaultRender,
  },
  {
    title: "Position ID",
    dataIndex: "positionId",
    render: defaultRender,
  },
  {
    title: "Symbol",
    dataIndex: "symbol",
    render: defaultRender,
  },
  {
    title: "Type",
    dataIndex: "type",
    render: defaultRender,
  },
  {
    title: "Volume",
    dataIndex: "volume",
    render: defaultRender,
  },
  {
    title: "Open Price",
    dataIndex: "priceOpen",
    render: defaultRender,
  },
  {
    title: "Close Price",
    dataIndex: "priceClose",
    render: defaultRender,
  },
  {
    title: "Profit",
    dataIndex: "profit",
    render: defaultRender,
  },
  {
    title: "Commission",
    dataIndex: "commission",
    render: defaultRender,
  },
  {
    title: "Swap",
    dataIndex: "swap",
    render: defaultRender,
  },
  {
    title: "Open Time",
    dataIndex: "openTime",
    render: defaultRender,
  },
  {
    title: "Close Time",
    dataIndex: "closeTime",
    render: defaultRender,
  },
  {
    title: "Status",
    dataIndex: "tradeStatus",
    render: defaultRender,
  },
];

export default columns;
